import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, fontFamilies, fontWeights, palette }: Theme) => ({
  title: {
    margin: '0 0 1.5rem',
    fontFamily: fontFamilies.primary,
    fontSize: '1.25rem',
    lineHeight: 1.4,
    fontWeight: fontWeights.medium,
    [breakpoints.up('md')]: {
      marginBottom: '0.5rem',
      fontSize: '1.75rem',
    },
  },
  kidsRadioSelected: {
    border: `1px solid ${palette.primary.main} !important`,
  },
}));
